import { DOCUMENT, inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { CurrentLanguageService } from '@shared/services/language';
import { PlatformContextService } from '@shared/services/platform-context';

/** Reloads the application on a navigation to another language, the language being fixed at its creation. */
export const languageReloadGuard: CanActivateFn = (_route, state) => {
  const currentLanguage = inject(CurrentLanguageService);
  const target = currentLanguage.resolve(state.url);
  const keepsLanguage = !target.served || target.language.locale === currentLanguage.language.locale;
  if (keepsLanguage || inject(PlatformContextService).isServer()) return true;
  inject(DOCUMENT).location.assign(state.url);
  return false;
};
